<template>
	 <div class="dynamiclist qualityenterprise"> 
				<leftnav class="fl" :title="'投资项目动态'"  mkcode="B" itemcode="B-DTJC"></leftnav> 
				<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''"> 
					<govheader></govheader>
					<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
						<freeUserTips :type="4" :bgtype="0"></freeUserTips>
					</el-dialog>
					<div class="index_left_centerpage">
						<div class="whitebox right_topbox" style="padding-bottom: 1px;">
							<div class="right_boxtitle">
								<span class="fl right_title">动态监测</span>
							<!-- 	<div class="fl search-box nz-search-box">
									<input type="text" :placeholder="searchPlaceholder" class="" v-model="searchtext"	@keydown="searchenter" />
									<button class="" @click="searchkwfun">查询</button>
								</div> -->
							</div> 
					 <div class="opport-screen-list1"> 
						<dynamicNav tabCode="tzxm"></dynamicNav> 
						<dl class="opport-screen bdbe">
							<dt class="fl">时间</dt>
							<dd class="fl">
								<span :key="index"  v-for="(item,index) in dayarry" @click="daychoose(item.key);" :class="timekey == item.key?'a-screen current':'a-screen'">{{item.name}}</span>
							</dd>
						</dl> 
						<dl class="opport-screen bdbe">
							<dt class="fl">热点产业</dt>
							<dd class="fl">
								<span :key="index" v-for="(item,index) in hotindustry" @click="industrychoose(1,item);" :class="industrycode1 == item.value?'a-screen current':'a-screen'">{{item.name}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="hotindustrychild.length>0">
							<dt class="fl titleop">细分产业</dt>
							<dd class="fl">
								 <span @click="industrycode2='';getdynamiclist()" :class="industrycode2 == ''?'a-screen current':'a-screen'">全部</span>
									<span :key="index"  v-for="(item,index) in hotindustrychild" @click="industrychoose(2,item);" :class="industrycode2 == item.value?'a-screen current':'a-screen'">{{item.name}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe">
							<dt class="fl titleop">动态类型</dt>
							<dd class="fl">
							 <span :class="dynamictype == 1 ?'a-screen current':'a-screen'" @click="dynamictypeToggle(1)" >全部动态</span>
								<span :class="dynamictype == 2 ?'a-screen current':'a-screen'" @click="dynamictypeToggle(2)">关注的企业动态</span>
							</dd>
						</dl>
						<div class="eninvest_list_screen oh" v-show="dynamictype==2">
							<h5 class="fl title">企业名称</h5>
							<div class="fl">
								<el-select v-model="stockChiness" placeholder="全部" @change="getEnterpriseName"><el-option  v-for="item in enterpriseOption"  :key="item.id"  :label="item.title"   :value="item.title"> </el-option> </el-select>
							</div>
							<span class="basebtn" @click="routerlinkid('/enterpirseinvestEdit')">添加企业</span>
						</div>
					</div>
				</div>
				<div class="whitebox" style="min-height: 160px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl"   v-if="kwtextsearch">产业大脑为您找到<span 	class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p> 
					</div>
					<div class="enterprise_list_box" >
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>公司名称</th>
								<th>项目名称</th>
								<th>投资来源地</th>
								<th>行业</th>
								<!-- <th>概念</th> -->
								<th>投资地点</th>
								<th :key="i" v-for="(list,i) in dimesmlist" >
									<div @click="tablesort(list.type);"  :style="'width:'+list.name.length*16+'px'" :class="{'td_sortname ':true,'current':orderField == list.type}" >
										<span		:class="{'sortname ':true,'current':orderField == list.type,'fz15':list.name.length>5}">{{list.name}}</span><span :class="orderType == 1?'timesorticon up':'timesorticon down'"></span>
									</div> 
									</th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterpristlist">
									<td>{{(page-1)*pageSize+i+1}}</td>
								<td>
									<span class="fwb curp" v-if="list.stockCode!=''"  @click="routerlinkid('/enterprises',list.stockCode)">{{list.shortName}}</span>
									<span v-if="list.stockCode==''">{{list.shortName}}</span>
									
								</td>
								<td style="width:200px;"><span :class="(list.url && list.url!='' )? 'curp':''" @click="openProjectLink(list.url)">{{list.projectName}}</span></td>
								<td>{{list.sourceArea}}</td>
								<td>{{list.industry}}</td>
								<!-- <td>{{list.notion}}</td> -->
								<td>{{list.investArea}}</td>
								<td>{{list.money}}{{list.moneyUnit}}</td>
								<td>{{list.time}}</td> 
							</tr>  
						</table>
					</div> 
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div> 
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'investDynamic',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data: function(){
			return{
		  userdata:{},curWebsite:this.$api.getWebsiteType(),  	title: '投资项目动态', stockcode:[],
				searchtype:1, industrycode1:"",industrycode2:0,industryid:0,orderField:0,orderType:0, 
				dayarry:[{name:"近一月",key:"month"},{name:'近一周',key:"week"},{name:"本日",key:"day"}],
				dimesmlist:[{name: '投资金额',type: 1}, {	name: '日期',type: 2},],enterpriseOption:[],searchstockCode:"all",stockChiness:'全部',
				hotindustry:[],hotindustrychild:[], timekey:'month',
				searchtext: "", dynamictype:1,
				kwtextsearch: false,
				kwtextsearchtext: "", 
				enterpristlist:[],
				showscreen: true,
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
				isShowFreeUserTips: false,
			};
		},
		created() { 
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
				this.userdata = this.getuseriformation(); 
				this.bus.$emit('loading', true);
		},
	 
		mounted() {
		if(this.userdata.edition<1){
			var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
			setTimeout(function(){
				_this.routerself('/totalEnterprises');
			},1000)
			return;
		}
		this.getenterOption();
		this.gethotindustry(); 
		this.getdynamiclist();
		},
		methods:{
			//投资动态跳转到投资项目库页面
			openProjectLink(url){
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				if(url && url!= ''){
						window.open(url); //研究报告库外部跳转
				} 
			},
			//全部动态和企业全部动态筛选
			dynamictypeToggle(type){
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				this.dynamictype=type;
				this.stockcode=type == 1?'':'all'; 
				this.getdynamiclist();
			},
			//时间筛选
			daychoose(key){
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				this.timekey=key;
				this.getdynamiclist();
			},
			industrychoose(step,list){
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				if(list.value == this.industryid){return;}
				var dtsg=[];
			 if(step == 1){
					this.hotindustrychild=list.children; 
					this.industrycode2='';
					this.industrycode1=list.value;
				}else if(step == 2){
					this.industrycode2=list.value;
				};
				this.industryid=list.value;
				this.getdynamiclist();
			} ,
			//获取用户设置的企业列表数据
			getenterOption(){ 
				var _this=this;
				var ajaxurl=this.$api.cyl.userenterprise.list();
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log(ajaxurl)
					// console.log('获取用户设置的企业列表数据',res.data.list)
					if (res.data.success) {
						_this.enterpriseOption=res.data.list.filter(list=>{
							return list.title!="";
						}); 
						_this.enterpriseOption.unshift({id:0,title:'全部',stockCode:"all"})
						_this.bus.$emit('loading', false);
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//点击设置当前搜索名字
			getEnterpriseName(val){
				console.log(val);
				var _this=this;
				this.enterpriseOption.forEach(list=>{
					if(list.title == val){
						_this.stockcode=list.stockCode;
						_this.getdynamiclist();
						return;
					}
				})
			},
		//获取热点行业分类
		gethotindustry(){
			var _this=this;
			this.$axios.get(this.$api.investapi.parameter.list()+"?categoryId=1" , {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function(res) {
				console.log('获取热点行业分类',res.data);
				let data1=res.data.list;
				var data2=[],data3=[];
				if (res.data.success) {
			   data2=data1.filter(list=>{
							return list.parentId*1<1;
						})
				 console.log(data2)
					data2.unshift({name:"全部",value:0,children:[]});
				_this.hotindustry=data2; 
				} else {
					
				}
			}).catch(function(error) {
				// 请求失败处理 console.log(error);
			});
		},
		//时间/分数升降序
		tablesort(field) {
			if (field == this.orderField) {
				this.orderType = Math.abs(this.orderType - 1);
			} else {
				this.orderField = field;
			}
			this.getdynamiclist();
			// this.ajaxsearchcompany();
		}, 
		//获取动态列表
		getdynamiclist(page){
			this.bus.$emit('loading', true);
			if(!page){
				page=1;this.page=1;
			}
			var stockja="";
			var industryja1 =this.splicing('industry1',this.industrycode1);
			var industryja2 =this.splicing('industry2',this.industrycode2);
			if(this.stockcode!=0 || this.stockcode!='' ){
				stockja ='&stockCode='+this.stockcode;
			} 
				var timeja =this.splicing('date1',this.timekey);
			var _this=this;
			var ajaxurl=this.$api.investapi.investdynamic.list()+'?orderField='+_this.orderField+'&orderType='+this.orderType+ industryja1+industryja2+stockja+timeja+'&page='+this.page;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function(res) {
				console.log(ajaxurl)
				console.log('获取动态列表',res.data)
				if (res.data.success) {
					_this.enterpristlist=res.data.list;
					
					_this.bus.$emit('loading', false);
			 _this.totalPage = res.data.totalPage;
			 _this.pageSize = res.data.pageSize;
			 _this.total = res.data.totalRecord;
				} else {
					
				}
			}).catch(function(error) {
				// 请求失败处理 console.log(error);
			});
		},
		//搜索关键词
		searchkwfun() {
			this.searchtext = $.trim(this.searchtext);
			// if(this.searchtext!="" || ){
			this.getdynamiclist();
			// } 
		},
		searchenter(e) {
			if (e.keyCode == 13) {
				this.searchkwfun();
			}
		},
		pageHandler: function(page) {
			this.page = page;
			this.getdynamiclist(page);
		}, 
		}
	}
</script>

<style>
	.a-red{
		color:#c00;
	}
	.right_boxtitle .el-tooltip{
		position: relative;top: 10px;
	}
</style>